// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import {
  ControllerInfoContent,
  unionToControllerInfoContent,
  unionListToControllerInfoContent,
} from "./controller-info-content";
import {
  ControllerLabelsMessage,
  ControllerLabelsMessageT,
  verifyControllerLabelsMessage,
} from "./controller-labels-message";
import {
  ControllerVersionInfoMessage,
  ControllerVersionInfoMessageT,
  verifyControllerVersionInfoMessage,
} from "./controller-version-info-message";
import {
  DispatcherVersionMessage,
  DispatcherVersionMessageT,
  verifyDispatcherVersionMessage,
} from "./dispatcher-version-message";
import {
  FirmwareVersionMessage,
  FirmwareVersionMessageT,
  verifyFirmwareVersionMessage,
} from "./firmware-version-message";
import {
  FloorLabelMessage,
  FloorLabelMessageT,
  verifyFloorLabelMessage,
} from "./floor-label-message";
import {
  FloorLabelsDataMessage,
  FloorLabelsDataMessageT,
  verifyFloorLabelsDataMessage,
} from "./floor-labels-data-message";
import {
  FloorPhysicalOpeningsMessage,
  FloorPhysicalOpeningsMessageT,
  verifyFloorPhysicalOpeningsMessage,
} from "./floor-physical-openings-message";
import {
  HallCallEligibilityMessage,
  HallCallEligibilityMessageT,
  verifyHallCallEligibilityMessage,
} from "./hall-call-eligibility-message";
import { JobNameMessage, JobNameMessageT, verifyJobNameMessage } from "./job-name-message";
import {
  ShuttleFloorsMessage,
  ShuttleFloorsMessageT,
  verifyShuttleFloorsMessage,
} from "./shuttle-floors-message";
import { BoolValue, BoolValueT, verifyBoolValue } from "../value/bool-value";
import { ByteValue, ByteValueT, verifyByteValue } from "../value/byte-value";
import { DoubleValue, DoubleValueT, verifyDoubleValue } from "../value/double-value";
import { FloatValue, FloatValueT, verifyFloatValue } from "../value/float-value";
import { IntValue, IntValueT, verifyIntValue } from "../value/int-value";
import { LongValue, LongValueT, verifyLongValue } from "../value/long-value";
import { ShortValue, ShortValueT, verifyShortValue } from "../value/short-value";
import { StringValue, StringValueT, verifyStringValue } from "../value/string-value";
import { UByteValue, UByteValueT, verifyUByteValue } from "../value/ubyte-value";
import { UIntValue, UIntValueT, verifyUIntValue } from "../value/uint-value";
import { ULongValue, ULongValueT, verifyULongValue } from "../value/ulong-value";
import { UShortValue, UShortValueT, verifyUShortValue } from "../value/ushort-value";
import { Value, unionToValue, unionListToValue } from "../value/value";

export class ValuedControllerInfo implements flatbuffers.IUnpackableObject<ValuedControllerInfoT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): ValuedControllerInfo {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsValuedControllerInfo(
    bb: flatbuffers.ByteBuffer,
    obj?: ValuedControllerInfo,
  ): ValuedControllerInfo {
    return (obj || new ValuedControllerInfo()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsValuedControllerInfo(
    bb: flatbuffers.ByteBuffer,
    obj?: ValuedControllerInfo,
  ): ValuedControllerInfo {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new ValuedControllerInfo()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  messageType(): ControllerInfoContent {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : ControllerInfoContent.NONE;
  }

  message<T extends flatbuffers.Table>(obj: any): any | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null;
  }

  valueType(): Value {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : Value.NONE;
  }

  value<T extends flatbuffers.Table>(obj: any): any | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null;
  }

  static startValuedControllerInfo(builder: flatbuffers.Builder) {
    builder.startObject(4);
  }

  static addMessageType(builder: flatbuffers.Builder, messageType: ControllerInfoContent) {
    builder.addFieldInt8(0, messageType, ControllerInfoContent.NONE);
  }

  static addMessage(builder: flatbuffers.Builder, messageOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, messageOffset, 0);
  }

  static addValueType(builder: flatbuffers.Builder, valueType: Value) {
    builder.addFieldInt8(2, valueType, Value.NONE);
  }

  static addValue(builder: flatbuffers.Builder, valueOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, valueOffset, 0);
  }

  static endValuedControllerInfo(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 6); // message
    return offset;
  }

  static createValuedControllerInfo(
    builder: flatbuffers.Builder,
    messageType: ControllerInfoContent,
    messageOffset: flatbuffers.Offset,
    valueType: Value,
    valueOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    ValuedControllerInfo.startValuedControllerInfo(builder);
    ValuedControllerInfo.addMessageType(builder, messageType);
    ValuedControllerInfo.addMessage(builder, messageOffset);
    ValuedControllerInfo.addValueType(builder, valueType);
    ValuedControllerInfo.addValue(builder, valueOffset);
    return ValuedControllerInfo.endValuedControllerInfo(builder);
  }

  unpack(): ValuedControllerInfoT {
    return new ValuedControllerInfoT(
      this.messageType(),
      (() => {
        const temp = unionToControllerInfoContent(this.messageType(), this.message.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })(),
      this.valueType(),
      (() => {
        const temp = unionToValue(this.valueType(), this.value.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })(),
    );
  }

  unpackTo(_o: ValuedControllerInfoT): void {
    _o.messageType = this.messageType();
    _o.message = (() => {
      const temp = unionToControllerInfoContent(this.messageType(), this.message.bind(this));
      if (temp === null) {
        return null;
      }
      return temp.unpack();
    })();
    _o.valueType = this.valueType();
    _o.value = (() => {
      const temp = unionToValue(this.valueType(), this.value.bind(this));
      if (temp === null) {
        return null;
      }
      return temp.unpack();
    })();
  }

  unpackFields(...fields: string[]): ValuedControllerInfoT {
    const t = new ValuedControllerInfoT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("message_type")) {
      t.messageType = this.messageType();
    }
    if (fieldSet.has("message")) {
      t.message = (() => {
        const temp = unionToControllerInfoContent(this.messageType(), this.message.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })();
    }
    if (fieldSet.has("value_type")) {
      t.valueType = this.valueType();
    }
    if (fieldSet.has("value")) {
      t.value = (() => {
        const temp = unionToValue(this.valueType(), this.value.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })();
    }
    return t;
  }
}

export class ValuedControllerInfoT implements flatbuffers.IGeneratedObject {
  constructor(
    public messageType: ControllerInfoContent = ControllerInfoContent.NONE,
    public message:
      | ControllerLabelsMessageT
      | ControllerVersionInfoMessageT
      | DispatcherVersionMessageT
      | FirmwareVersionMessageT
      | FloorLabelMessageT
      | FloorLabelsDataMessageT
      | FloorPhysicalOpeningsMessageT
      | HallCallEligibilityMessageT
      | JobNameMessageT
      | ShuttleFloorsMessageT
      | null = null,
    public valueType: Value = Value.NONE,
    public value:
      | BoolValueT
      | ByteValueT
      | DoubleValueT
      | FloatValueT
      | IntValueT
      | LongValueT
      | ShortValueT
      | StringValueT
      | UByteValueT
      | UIntValueT
      | ULongValueT
      | UShortValueT
      | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.message === null || this.message === undefined) {
      throw new Error('Required field "message" is not set');
    }
    const message = builder.createObjectOffset(this.message);
    const value = builder.createObjectOffset(this.value);

    return ValuedControllerInfo.createValuedControllerInfo(
      builder,
      this.messageType,
      message,
      this.valueType,
      value,
    );
  }

  clone(): ValuedControllerInfoT {
    const obj = new ValuedControllerInfoT();
    obj.messageType = this.messageType;
    obj.message =
      this.message !== null && typeof (this.message as any).clone === "function"
        ? (this.message as any).clone()
        : this.message;
    obj.valueType = this.valueType;
    obj.value =
      this.value !== null && typeof (this.value as any).clone === "function"
        ? (this.value as any).clone()
        : this.value;
    return obj;
  }

  equals(other: ValuedControllerInfoT): boolean {
    if (this.messageType !== other.messageType) return false;
    if (this.message !== null && other.message !== null) {
      if (typeof (this.message as any).equals === "function") {
        if (!(this.message as any).equals(other.message)) return false;
      } else if (this.message !== other.message) return false;
    } else if (this.message !== other.message) return false;
    if (this.valueType !== other.valueType) return false;
    if (this.value !== null && other.value !== null) {
      if (typeof (this.value as any).equals === "function") {
        if (!(this.value as any).equals(other.value)) return false;
      } else if (this.value !== other.value) return false;
    } else if (this.value !== other.value) return false;
    return true;
  }
}

export function verifyValuedControllerInfo(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 1);
    verifier.checkUnionConsistency(tablePos, 4, 6, "message");
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        const uType = verifier.readFieldUint8(tablePos, 4);
        switch (uType) {
          case 1: // FloorLabelMessage
            {
              const o = verifier.readInt32(pos);
              verifyFloorLabelMessage(verifier, pos + o);
            }
            break;
          case 2: // FirmwareVersionMessage
            {
              const o = verifier.readInt32(pos);
              verifyFirmwareVersionMessage(verifier, pos + o);
            }
            break;
          case 3: // ControllerLabelsMessage
            {
              const o = verifier.readInt32(pos);
              verifyControllerLabelsMessage(verifier, pos + o);
            }
            break;
          case 4: // FloorLabelsDataMessage
            {
              const o = verifier.readInt32(pos);
              verifyFloorLabelsDataMessage(verifier, pos + o);
            }
            break;
          case 5: // DispatcherVersionMessage
            {
              const o = verifier.readInt32(pos);
              verifyDispatcherVersionMessage(verifier, pos + o);
            }
            break;
          case 6: // ControllerVersionInfoMessage
            {
              const o = verifier.readInt32(pos);
              verifyControllerVersionInfoMessage(verifier, pos + o);
            }
            break;
          case 7: // JobNameMessage
            {
              const o = verifier.readInt32(pos);
              verifyJobNameMessage(verifier, pos + o);
            }
            break;
          case 8: // FloorPhysicalOpeningsMessage
            {
              const o = verifier.readInt32(pos);
              verifyFloorPhysicalOpeningsMessage(verifier, pos + o);
            }
            break;
          case 9: // HallCallEligibilityMessage
            {
              const o = verifier.readInt32(pos);
              verifyHallCallEligibilityMessage(verifier, pos + o);
            }
            break;
          case 10: // ShuttleFloorsMessage
            {
              const o = verifier.readInt32(pos);
              verifyShuttleFloorsMessage(verifier, pos + o);
            }
            break;
        }
      }
    }
    verifier.checkRequiredField(tablePos, 6, "message");
    verifier.checkScalarField(tablePos, 8, 1);
    verifier.checkUnionConsistency(tablePos, 8, 10, "value");
    {
      const pos = verifier.checkOffsetField(tablePos, 10);
      if (pos !== 0) {
        const uType = verifier.readFieldUint8(tablePos, 8);
        switch (uType) {
          case 1: // BoolValue
            {
              const o = verifier.readInt32(pos);
              verifyBoolValue(verifier, pos + o);
            }
            break;
          case 2: // ByteValue
            {
              const o = verifier.readInt32(pos);
              verifyByteValue(verifier, pos + o);
            }
            break;
          case 3: // UByteValue
            {
              const o = verifier.readInt32(pos);
              verifyUByteValue(verifier, pos + o);
            }
            break;
          case 4: // ShortValue
            {
              const o = verifier.readInt32(pos);
              verifyShortValue(verifier, pos + o);
            }
            break;
          case 5: // UShortValue
            {
              const o = verifier.readInt32(pos);
              verifyUShortValue(verifier, pos + o);
            }
            break;
          case 6: // IntValue
            {
              const o = verifier.readInt32(pos);
              verifyIntValue(verifier, pos + o);
            }
            break;
          case 7: // UIntValue
            {
              const o = verifier.readInt32(pos);
              verifyUIntValue(verifier, pos + o);
            }
            break;
          case 8: // LongValue
            {
              const o = verifier.readInt32(pos);
              verifyLongValue(verifier, pos + o);
            }
            break;
          case 9: // ULongValue
            {
              const o = verifier.readInt32(pos);
              verifyULongValue(verifier, pos + o);
            }
            break;
          case 10: // FloatValue
            {
              const o = verifier.readInt32(pos);
              verifyFloatValue(verifier, pos + o);
            }
            break;
          case 11: // DoubleValue
            {
              const o = verifier.readInt32(pos);
              verifyDoubleValue(verifier, pos + o);
            }
            break;
          case 12: // StringValue
            {
              const o = verifier.readInt32(pos);
              verifyStringValue(verifier, pos + o);
            }
            break;
        }
      }
    }
  } finally {
    verifier.popDepth();
  }
}
